const videoMap = {
    "Watertank_Way11052018.mp4": `${process.env.PUBLIC_URL}/videos/Watertank_Way11052018.mp4`,
    "GOPR0046.MP4": `${process.env.PUBLIC_URL}/videos/GOPR0046-1.mp4`,
    "HydeParkCut.MP4": `${process.env.PUBLIC_URL}/videos/HydeParkCut-1.mp4`,
}

export default (video) => {
    const fileName = video.meta.FileName;
    return videoMap[fileName] || `http://18.188.81.200/api/streaming/${video.meta.FileName}`;
}


// WEBPACK FOOTER //
// ./src/modules/get-video-url.js